import {
  Login,
  Leftmenu,
  Topbar,
  Home,
  Homemain,
  Homevfpmenu,
  Homemessage,
  Homememo,
  Homecontact,
  Crmmain,
  Crmvfpmenu,
  Crmchance,
  Crm,
  Crmchancestat,
  Crmhope,
  Crmhopecolleague,
  Crmhopeshare,
  Crmhopestat,
  Client,
  Clientmain,
  Clientvfpmenu,
  Clientsign,
  Clientsigncolleague,
  Clientsignstat,
  Clientsignshare,
  Clientcontract,
  Visit,
  Visitmain,
  Visitstat,
  Visitunit,
  Visitrecord,
  Visitvfpmenu,
  Recruitmentvfpmenu,
  Recruitment,
  Recruitmentinterview,
  Recruitmenteesume,
  Recruitmentmain,
  Usermain,
  Uservfpmenu,
  Userlogs,
  Setting,
  Settingrole,
  Settingaccount,
  Settingvfpmenu,
  Settinglogs,
  Settingclient,
  Settingcrm,
  Settingrecruitment,
  Settingvisit,
  Settinglink,
  Homeaffiche,
  Crmrecycle,
  Crmblacklist,
  Crmfilter,
  Crmlecture, Crmhintduty, Crmhintshare, User,
} from './imports';

export const routes = [
  // 首页大厅
  {
    path: '/home',
    children: [
      // 资产仓库
      {
        path: '/home',
        name: 'home',
        components: {
          default: Homemain,
          'ui-leftmenu': Leftmenu,
          'ui-vfpmenu': Homevfpmenu,
          'ui-topbar': Topbar,
        },
        meta: {
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth: true,
          // 导航信息
          navArr: [{ title: '首页', path: '/home' }, { title: '工作台', path: '' }],
        },
      },
      // 资产仓库
      {
        path: '/home/message',
        name: 'homemessage',
        components: {
          default: Homemessage,
          'ui-leftmenu': Leftmenu,
          'ui-vfpmenu': Homevfpmenu,
          'ui-topbar': Topbar,
        },
        meta: {
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth: true,
          // 导航信息
          navArr: [{ title: '首页', path: '/home' }, { title: '我的消息', path: '' }],
        },
      },
      // 资产仓库
      {
        path: '/home/affiche',
        name: 'homeaffiche',
        components: {
          default: Homeaffiche,
          'ui-leftmenu': Leftmenu,
          'ui-vfpmenu': Homevfpmenu,
          'ui-topbar': Topbar,
        },
        meta: {
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth: true,
          navArr: [{ title: '首页', path: '/home' }, { title: '公示公告', path: '' }],
        },
      },
      // 资产仓库
      {
        path: '/home/memo',
        name: 'homememo',
        components: {
          default: Homememo,
          'ui-leftmenu': Leftmenu,
          'ui-vfpmenu': Homevfpmenu,
          'ui-topbar': Topbar,
        },
        meta: {
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth: true,
          navArr: [{ title: '首页', path: '/home' }, { title: '备忘录', path: '' }],
        },
      },
      // 资产仓库
      {
        path: '/home/contact',
        name: 'homecontact',
        components: {
          default: Homecontact,
          'ui-leftmenu': Leftmenu,
          'ui-vfpmenu': Homevfpmenu,
          'ui-topbar': Topbar,
        },
        meta: {
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth: true,
          navArr: [{ title: '首页', path: '/home' }, { title: '通讯录', path: '' }],
        },
      },
    ],
    meta: {
      // 需要登录控制
      NProgress: false,
      // 需要登录控制
      requireAuth: true,
    },
    component: Home,
  },
  // 机会
  {
    path: '/crm',
    children: [
      // 工作台
      {
        path: '/crm',
        name: 'crm',
        components: {
          default: Crmmain,
          'ui-leftmenu': Leftmenu,
          'ui-vfpmenu': Crmvfpmenu,
          'ui-topbar': Topbar,
        },
        meta: {
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth: true,
          // 权限标点
          rbacNode: 'crm',
          navArr: [{ title: '机会', path: '/crm' }, { title: '工作台', path: '' }],
        },
      },
      // 公海机会
      {
        path: '/crm/chance',
        name: 'crmchance',
        components: {
          default: Crmchance,
          'ui-leftmenu': Leftmenu,
          'ui-vfpmenu': Crmvfpmenu,
          'ui-topbar': Topbar,
        },
        meta: {
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth: true,
          rbacNode: 'crm/chance',
          navArr: [{ title: '机会', path: '/crm' }, { title: '公海机会', path: '' }],
        },
      },
      // 机会统计
      {
        path: '/crm/chancestat',
        name: 'crmchancestat',
        components: {
          default: Crmchancestat,
          'ui-leftmenu': Leftmenu,
          'ui-vfpmenu': Crmvfpmenu,
          'ui-topbar': Topbar,
        },
        meta: {
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth: true,
          rbacNode: 'crm/chancestat',
          navArr: [{ title: '机会', path: '/crm' }, { title: '机会统计', path: '' }],
        },
      },
      // 机会统计
      {
        path: '/crm/hope',
        name: 'crmhope',
        components: {
          default: Crmhope,
          'ui-leftmenu': Leftmenu,
          'ui-vfpmenu': Crmvfpmenu,
          'ui-topbar': Topbar,
        },
        meta: {
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth: true,
          rbacNode: 'crm/hope',
          navArr: [{ title: '机会', path: '/crm' }, { title: '我的意向', path: '' }],
        },
      },

      // 机会统计
      {
        path: '/crm/recycle',
        name: 'crmrecycle',
        components: {
          default: Crmrecycle,
          'ui-leftmenu': Leftmenu,
          'ui-vfpmenu': Crmvfpmenu,
          'ui-topbar': Topbar,
        },
        meta: {
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth: true,
          rbacNode: 'crm/recycle',
          navArr: [{ title: '回收站', path: '/crm' }, { title: '我的意向', path: '' }],
        },
      },

      // 机会统计
      {
        path: '/crm/hintduty',
        name: 'crmhintduty',
        components: {
          default: Crmhintduty,
          'ui-leftmenu': Leftmenu,
          'ui-vfpmenu': Crmvfpmenu,
          'ui-topbar': Topbar,
        },
        meta: {
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth: true,
          rbacNode: 'crm/hope',
          navArr: [{ title: '48小时后失去客户', path: '/crm' }, { title: '我的意向', path: '' }],
        },
      },

      // 机会统计
      {
        path: '/crm/hintshare',
        name: 'crmhintshare',
        components: {
          default: Crmhintshare,
          'ui-leftmenu': Leftmenu,
          'ui-vfpmenu': Crmvfpmenu,
          'ui-topbar': Topbar,
        },
        meta: {
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth: true,
          rbacNode: 'crm/hopeshare',
          navArr: [{ title: '48小时后失去共享', path: '/crm' }, { title: '我的意向', path: '' }],
        },
      },

      // 机会统计
      {
        path: '/crm/blacklist',
        name: 'crmblacklist',
        components: {
          default: Crmblacklist,
          'ui-leftmenu': Leftmenu,
          'ui-vfpmenu': Crmvfpmenu,
          'ui-topbar': Topbar,
        },
        meta: {
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth: true,
          rbacNode: 'crm/blacklist',
          navArr: [{ title: '黑名单', path: '/crm' }, { title: '我的意向', path: '' }],
        },
      },
      // 机会统计
      {
        path: '/crm/filter',
        name: 'crmfilter',
        components: {
          default: Crmfilter,
          'ui-leftmenu': Leftmenu,
          'ui-vfpmenu': Crmvfpmenu,
          'ui-topbar': Topbar,
        },
        meta: {
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth: true,
          rbacNode: 'crm/filter',
          navArr: [{ title: '全局检索', path: '/crm' }, { title: '我的意向', path: '' }],
        },
      },

      // 机会统计
      {
        path: '/crm/hopecolleague',
        name: 'crmhopecolleague',
        components: {
          default: Crmhopecolleague,
          'ui-leftmenu': Leftmenu,
          'ui-vfpmenu': Crmvfpmenu,
          'ui-topbar': Topbar,
        },
        meta: {
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth: true,
          rbacNode: 'crm/hopecolleague',
          navArr: [{ title: '机会', path: '/crm' }, { title: '我的同事', path: '' }],
        },
      },
      // 机会统计
      {
        path: '/crm/hopeshare',
        name: 'crmhopeshare',
        components: {
          default: Crmhopeshare,
          'ui-leftmenu': Leftmenu,
          'ui-vfpmenu': Crmvfpmenu,
          'ui-topbar': Topbar,
        },
        meta: {
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth: true,
          rbacNode: 'crm/hopeshare',
          navArr: [{ title: '机会', path: '/crm' }, { title: '共享到的', path: '' }],
        },
      },
      // 机会统计
      {
        path: '/crm/hopestat',
        name: 'crmhopestat',
        components: {
          default: Crmhopestat,
          'ui-leftmenu': Leftmenu,
          'ui-vfpmenu': Crmvfpmenu,
          'ui-topbar': Topbar,
        },
        meta: {
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth: true,
          rbacNode: 'crm/hopestat',
          navArr: [{ title: '机会', path: '/crm' }, { title: '数据统计', path: '' }],
        },
      },
    ],
    meta: {
      // 需要登录控制
      NProgress: false,
      // 需要登录控制
      requireAuth: true,
    },
    component: Crm,
  },
  // 机会
  {
    path: '/client',
    children: [
      // 工作台
      {
        path: '/client',
        name: 'client',
        components: {
          default: Clientmain,
          'ui-leftmenu': Leftmenu,
          'ui-vfpmenu': Clientvfpmenu,
          'ui-topbar': Topbar,
        },
        meta: {
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth: true,
          rbacNode: 'client',
          navArr: [{ title: '客户', path: '/client' }, { title: '工作台', path: '' }],
        },
      },
      // 工作台
      {
        path: '/client/sign',
        name: 'clientsign',
        components: {
          default: Clientsign,
          'ui-leftmenu': Leftmenu,
          'ui-vfpmenu': Clientvfpmenu,
          'ui-topbar': Topbar,
        },
        meta: {
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth: true,
          rbacNode: 'client/sign',
          navArr: [{ title: '客户', path: '/client' }, { title: '我负责的', path: '' }],
        },
      },
      // 工作台
      {
        path: '/client/signcolleague',
        name: 'clientsigncolleague',
        components: {
          default: Clientsigncolleague,
          'ui-leftmenu': Leftmenu,
          'ui-vfpmenu': Clientvfpmenu,
          'ui-topbar': Topbar,
        },
        meta: {
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth: true,
          rbacNode: 'client/signcolleague',
          navArr: [{ title: '客户', path: '/client' }, { title: '我的同事', path: '' }],
        },
      },
      // 工作台
      {
        path: '/client/signshare',
        name: 'clientsignshare',
        components: {
          default: Clientsignshare,
          'ui-leftmenu': Leftmenu,
          'ui-vfpmenu': Clientvfpmenu,
          'ui-topbar': Topbar,
        },
        meta: {
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth: true,
          rbacNode: 'client/signshare',
          navArr: [{ title: '客户', path: '/client' }, { title: '共享到的', path: '' }],
        },
      },
      // 工作台
      {
        path: '/client/signstat',
        name: 'clientsignstat',
        components: {
          default: Clientsignstat,
          'ui-leftmenu': Leftmenu,
          'ui-vfpmenu': Clientvfpmenu,
          'ui-topbar': Topbar,
        },
        meta: {
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth: true,
          rbacNode: 'client/signstat',
          navArr: [{ title: '客户', path: '/client' }, { title: '数据统计', path: '' }],
        },
      },
      // 工作台
      {
        path: '/client/contract',
        name: 'clientcontract',
        components: {
          default: Clientcontract,
          'ui-leftmenu': Leftmenu,
          'ui-vfpmenu': Clientvfpmenu,
          'ui-topbar': Topbar,
        },
        meta: {
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth: true,
          rbacNode: 'client/contract',
          navArr: [{ title: '客户', path: '/client' }, { title: '合同文件', path: '' }],
        },
      },
      // 机会统计
      {
        path: '/client/recycle',
        name: 'clientrecycle',
        components: {
          default: Crmrecycle,
          'ui-leftmenu': Leftmenu,
          'ui-vfpmenu': Clientvfpmenu,
          'ui-topbar': Topbar,
        },
        meta: {
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth: true,
          rbacNode: 'client/recycle',
          navArr: [{ title: '回收站', path: '/crm' }, { title: '我的意向', path: '' }],
        },
      },

      // 机会统计
      {
        path: '/client/blacklist',
        name: 'clientblacklist',
        components: {
          default: Crmblacklist,
          'ui-leftmenu': Leftmenu,
          'ui-vfpmenu': Clientvfpmenu,
          'ui-topbar': Topbar,
        },
        meta: {
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth: true,
          rbacNode: 'client/blacklist',
          navArr: [{ title: '黑名单', path: '/crm' }, { title: '我的意向', path: '' }],
        },
      },
      // 机会统计
      {
        path: '/client/filter',
        name: 'clientfilter',
        components: {
          default: Crmfilter,
          'ui-leftmenu': Leftmenu,
          'ui-vfpmenu': Clientvfpmenu,
          'ui-topbar': Topbar,
        },
        meta: {
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth: true,
          rbacNode: 'client/filter',
          navArr: [{ title: '全局检索', path: '/crm' }, { title: '我的意向', path: '' }],
        },
      },
    ],
    meta: {
      // 需要登录控制
      NProgress: false,
      // 需要登录控制
      requireAuth: true,
    },
    component: Client,
  },
  // 签到
  {
    path: '/visit',
    children: [
      // 工作台
      {
        path: '/visit',
        name: 'visit',
        components: {
          default: Visitmain,
          'ui-leftmenu': Leftmenu,
          'ui-vfpmenu': Visitvfpmenu,
          'ui-topbar': Topbar,
        },
        meta: {
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth: true,
          rbacNode: 'visit',
          navArr: [{ title: '签到', path: '/visit' }, { title: '工作台', path: '' }],
        },
      },
      // 工作台
      {
        path: '/visit/record',
        name: 'visitrecord',
        components: {
          default: Visitrecord,
          'ui-leftmenu': Leftmenu,
          'ui-vfpmenu': Visitvfpmenu,
          'ui-topbar': Topbar,
        },
        meta: {
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth: true,
          rbacNode: 'visit/record',
          navArr: [{ title: '签到', path: '/visit' }, { title: '签到记录', path: '' }],
        },
      },
      // 工作台
      {
        path: '/visit/unit',
        name: 'visitunit',
        components: {
          default: Visitunit,
          'ui-leftmenu': Leftmenu,
          'ui-vfpmenu': Visitvfpmenu,
          'ui-topbar': Topbar,
        },
        meta: {
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth: true,
          rbacNode: 'visit/unit',
          navArr: [{ title: '签到', path: '/visit' }, { title: '事件管理', path: '' }],
        },
      },
      // 工作台
      {
        path: '/visit/stat',
        name: 'visitstat',
        components: {
          default: Visitstat,
          'ui-leftmenu': Leftmenu,
          'ui-vfpmenu': Visitvfpmenu,
          'ui-topbar': Topbar,
        },
        meta: {
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth: true,
          rbacNode: 'visit/stat',
          navArr: [{ title: '签到', path: '/visit' }, { title: '数据统计', path: '' }],
        },
      },
    ],
    meta: {
      // 需要登录控制
      NProgress: false,
      // 需要登录控制
      requireAuth: true,
    },
    component: Visit,
  },
  // 招聘
  {
    path: '/recruitment',
    children: [
      // 工作台
      {
        path: '/recruitment',
        name: 'recruitment',
        components: {
          default: Recruitmentmain,
          'ui-leftmenu': Leftmenu,
          'ui-vfpmenu': Recruitmentvfpmenu,
          'ui-topbar': Topbar,
        },
        meta: {
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth: true,
          rbacNode: 'recruitment',
          navArr: [{ title: '招聘', path: '/recruitment' }, { title: '工作台', path: '' }],
        },
      },
      // 工作台
      {
        path: '/recruitment/resume',
        name: 'recruitmentresume',
        components: {
          default: Recruitmenteesume,
          'ui-leftmenu': Leftmenu,
          'ui-vfpmenu': Recruitmentvfpmenu,
          'ui-topbar': Topbar,
        },
        meta: {
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth: true,
          rbacNode: 'recruitment/resume',
          navArr: [{ title: '招聘', path: '/recruitment' }, { title: '人才库', path: '' }],
        },
      },
      // 工作台
      {
        path: '/recruitment/interview',
        name: 'recruitmentinterview',
        components: {
          default: Recruitmentinterview,
          'ui-leftmenu': Leftmenu,
          'ui-vfpmenu': Recruitmentvfpmenu,
          'ui-topbar': Topbar,
        },
        meta: {
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth: true,
          rbacNode: 'recruitment/interview',
          navArr: [{ title: '招聘', path: '/recruitment' }, { title: '面试安排', path: '' }],
        },
      },
    ],
    meta: {
      // 需要登录控制
      NProgress: false,
      // 需要登录控制
      requireAuth: true,
    },
    component: Recruitment,
  },
  // 我的
  {
    path: '/user',
    children: [
      // 工作台
      {
        path: '/user',
        name: 'user',
        components: {
          default: Usermain,
          'ui-leftmenu': Leftmenu,
          'ui-vfpmenu': Uservfpmenu,
          'ui-topbar': Topbar,
        },
        meta: {
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth: true,
          navArr: [{ title: '我的', path: '/user' }, { title: '我的信息', path: '' }],
        },
      },
      // 工作台
      {
        path: '/user/logs',
        name: 'userlogs',
        components: {
          default: Userlogs,
          'ui-leftmenu': Leftmenu,
          'ui-vfpmenu': Uservfpmenu,
          'ui-topbar': Topbar,
        },
        meta: {
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth: true,
          rbacNode: 'user/logs',
          navArr: [{ title: '我的', path: '/user' }, { title: '登陆日志', path: '' }],
        },
      },
    ],
    meta: {
      // 需要登录控制
      NProgress: false,
      // 需要登录控制
      requireAuth: true,
    },
    component: User,
  },
  // 设置
  {
    path: '/setting',
    children: [
      // 工作台
      {
        path: '/setting',
        name: 'setting',
        components: {
          default: Settinglogs,
          'ui-leftmenu': Leftmenu,
          'ui-vfpmenu': Settingvfpmenu,
          'ui-topbar': Topbar,
        },
        meta: {
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth: true,
          rbacNode: 'setting/logs',
          navArr: [{ title: '系统', path: '/setting' }, { title: '登录日志', path: '' }],
        },
      },
      // 工作台
      {
        path: '/setting/account',
        name: 'settinglogs',
        components: {
          default: Settingaccount,
          'ui-leftmenu': Leftmenu,
          'ui-vfpmenu': Settingvfpmenu,
          'ui-topbar': Topbar,
        },
        meta: {
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth: true,
          rbacNode: 'setting/account',
          navArr: [{ title: '系统', path: '/setting' }, { title: '账号统筹', path: '' }],
        },
      },
      // 工作台
      // {
      //   path: '/setting/client',
      //   name: 'settingclient',
      //   components: {
      //     default: Settingclient,
      //     'ui-leftmenu': Leftmenu,
      //     'ui-vfpmenu': Settingvfpmenu,
      //     'ui-topbar': Topbar,
      //   },
      //   meta: {
      //     // 需要登录控制
      //     NProgress: true,
      //     // 需要登录控制
      //     requireAuth: true,
      //     navArr: [{ title: '系统', path: '/setting' }, { title: '访问控制', path: '' }],
      //   },
      // },
      // 工作台
      {
        path: '/setting/crm',
        name: 'settingcrm',
        components: {
          default: Settingcrm,
          'ui-leftmenu': Leftmenu,
          'ui-vfpmenu': Settingvfpmenu,
          'ui-topbar': Topbar,
        },
        meta: {
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth: true,
          rbacNode: 'setting/crm',
          navArr: [{ title: '系统', path: '/setting' }, { title: '机会模块', path: '' }],
        },
      },
      // 工作台
      {
        path: '/setting/link',
        name: 'settinglink',
        components: {
          default: Settinglink,
          'ui-leftmenu': Leftmenu,
          'ui-vfpmenu': Settingvfpmenu,
          'ui-topbar': Topbar,
        },
        meta: {
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth: true,
          rbacNode: 'setting/link',
          navArr: [{ title: '系统', path: '/setting' }, { title: '客户模块', path: '' }],
        },
      },
      // 工作台
      {
        path: '/setting/role',
        name: 'settingrole',
        components: {
          default: Settingrole,
          'ui-leftmenu': Leftmenu,
          'ui-vfpmenu': Settingvfpmenu,
          'ui-topbar': Topbar,
        },
        meta: {
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth: true,
          rbacNode: 'setting/role',
          navArr: [{ title: '系统', path: '/setting' }, { title: '角色管理', path: '' }],
        },
      },
      // 工作台
      {
        path: '/setting/recruitment',
        name: 'settingrecruitment',
        components: {
          default: Settingrecruitment,
          'ui-leftmenu': Leftmenu,
          'ui-vfpmenu': Settingvfpmenu,
          'ui-topbar': Topbar,
        },
        meta: {
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth: true,
          rbacNode: 'setting/recruitment',
          navArr: [{ title: '系统', path: '/setting' }, { title: '签到模块', path: '' }],
        },
      },
      // 工作台
      // {
      //   path: '/setting/visit',
      //   name: 'settingvisit',
      //   components: {
      //     default: Settingvisit,
      //     'ui-leftmenu': Leftmenu,
      //     'ui-vfpmenu': Settingvfpmenu,
      //     'ui-topbar': Topbar,
      //   },
      //   meta: {
      //     // 需要登录控制
      //     NProgress: true,
      //     // 需要登录控制
      //     requireAuth: true,
      //     navArr: [{ title: '系统', path: '/setting' }, { title: '招聘模块', path: '' }],
      //   },
      // },
    ],
    meta: {
      // 需要登录控制
      NProgress: false,
      // 需要登录控制
      requireAuth: true,
    },
    component: Setting,
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: {
      // 需要登录控制
      NProgress: true,
      // 需要登录控制
      requireAuth: false,
    },
  },
  {
    path: '/lecture',
    name: 'lecture',
    component: Crmlecture,
    meta: {
      // 需要登录控制
      NProgress: true,
      // 需要登录控制
      requireAuth: false,
    },
  },
  {
    path: '*',
    redirect: '/login',
    meta: {
      // 需要登录控制
      NProgress: true,
      // 需要登录控制
      requireAuth: false,
    },
  },
];



// WEBPACK FOOTER //
// ./src/router/routes.js